import React, { useEffect, useState } from 'react';

// Styles
import './styles.scss';
import { withRouter } from 'react-router-dom';

// Components
import Sidemenu from '../../Components/Sidemenu/Sidemenu';
import HamburgerMenu from '../../Components/HamburgerMenu/HamburgerMenu';
import { connect } from 'react-redux';
import Expired from '../Expired/Expired';
import { GE_DOMAIN } from 'src/Config/constants';

const MenuWrapper = ({
  isMenuVisible,
  setHamburgerVisibility,
  children,
  subscription,
  generic,
  history,
  manageSidemenu,
  registration,
}) => {
  const setStyles = () => {
    let sideMenuExists = document.querySelector('.desktop-menu');
    if (sideMenuExists == null) {
      return {
        menuCompWrapper: {
          padding: '0',
        },
        compContainer: {
          gridColumn: '1 / 13',
        },
      };
    }
    return {};
  };

  /* Since we are redirecting on 500 error (serverErrorMessage), so we have some pages in which redirection should not be there,
  that is why we have this flag to uncheck it if we do not want to redirect to 500 error screen url, by adding suitable conditions */
  let shouldRedirectOnServerErr = true;
  let pathname = history.location.pathname;
  const [menuStyles, setMenuStyles] = useState(setStyles);

  // Set styles after 1st render (When hydrated)
  useEffect(() => {
    if ( pathname && !pathname.includes('add')) {
      manageSidemenu(false);
    }
    setMenuStyles(setStyles);
  }, [isMenuVisible]);

  let { isSideMenuHidden } = generic;

  localStorage.setItem('darkTheme', true);

  const getServerRedirectErr = (arr) => {
    if ((arr.length === 3 || arr.length === 4) && (arr[0] === '' && arr[1] === 'course')) {
      return false;
    }
  }

  if (pathname.includes('/course/')) {
    const arr = pathname.split('/');
    shouldRedirectOnServerErr = getServerRedirectErr(arr);
  }

  if (
    generic.serverErrorMessage &&
    typeof window !== 'undefined' &&
    shouldRedirectOnServerErr &&
    window.location.href.indexOf('internalServerError') < 0
  ) {
    history.push('/internalServerError');
  }

  let target = document.querySelectorAll('.overlay-true');
  const mainContainer = document.querySelector('.component-container');
  const sideMenuAvailable = document.querySelector('.desktop-menu');

  const getContainerCss = () => {
    if (mainContainer !== null) {
      mainContainer.style.pointerEvents = 'all';
      mainContainer.style.position = 'relative';
    }
  }

  if (target.length > 0) {
    mainContainer.style.pointerEvents = 'none';
  } else {
    getContainerCss();
  }

  if (!sideMenuAvailable) {
    if (mainContainer !== null) {
      mainContainer.style.gridColumn = '1 / 13';
    }
  } else {
    mainContainer.style.gridColumn = '2 / 13';
  }
  let windowPathname = window.location.pathname;
  const isConfirmationPage = () => {
    if (windowPathname.includes('/confirm')) {
      const arr1 = windowPathname.split('/');
      if (arr1.length === 4 && arr1[3] === 'confirm')
          return true;
    }
    return false;
  }
  let loginType = localStorage.getItem('loginType');

  const renderExpirationScreen = () => {
    let status = registration?.accountStatus?.status;
    if(!subscription.isForbidden){
      return (
      <div
        className="component-container"
        style={{ ...menuStyles.compContainer }}
      >
        {children}
      </div>
      )
    }else{
      if(status === 'COMPLETED_SETUP') {
        return (
          <div
            className="component-container"
            style={{ ...menuStyles.compContainer }}
          >
            <Expired />
          </div>
        )
      }
    }
  }
  return (
    <div
      className={`menu-and-component-wrapper${isConfirmationPage() ? " remove-grid-gap" : ""}`}
      style={{ ...menuStyles.menuCompWrapper }}
    >
      {(loginType === GE_DOMAIN || Object.values(subscription.activeConfigList).includes(true)) &&
        !isSideMenuHidden &&
        !subscription.isForbidden &&
        (!generic.serverErrorMessage || !shouldRedirectOnServerErr) &&
        window.location.href.indexOf('internalServerError') < 0 &&
        window.location.href.indexOf('adminAcknowledge') < 0 && (
          <>
            <div className="desktop-menu">
              <Sidemenu />
            </div>
            <div className="mobile-menu">
              <HamburgerMenu setHamburgerVisibility={setHamburgerVisibility} />
            </div>
          </>
        )}
        {renderExpirationScreen()}
    </div>
  );
};

export const mapStateToProps = ({
  generic,
  subscription,
  collab,
  registration,
}) => ({
  generic,
  subscription,
  collab,
  registration,
});

export default withRouter(connect(mapStateToProps)(MenuWrapper));
